

























// 2023.07.21 [2023F-06] add
import { Component, Vue, Watch, Emit, Prop } from 'vue-property-decorator';
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);
@Component
export default class VariableSelectChangeEvent extends Vue {
  private validate = require('../../CommonUtils/fixed/Validate'); // Validate
  private privateInvaildMessage: string = '';
  private rules: any;
  private privateTextColor: string = '';
  // クリアボタンの設定
  // private clearable: boolean = false;
  @Prop() private name!: string;
  @Prop() private value?: string;
  @Prop() private readonly?: string;
  @Prop() private disabled?: string;
  @Prop() private required?: string;
  @Prop() private options!: [];
  @Prop() private invaildMessage?: string;
  @Prop() private textColor?: string;
  @Emit('input')
  private selectValue(value: string) {
    this.emitAddress(value);
  }

  @Emit('emitAddress')
  // VariableScreen.vueのcomponent記載の@emitAddressと一旦合わせないと呼び出されない為名前はemitAdressのまま
  //実際に呼び出されるのはVariableScreen.vue記載のemitAddressメソッドではなくMailTemplateInfo.vueの@emitAddressで再定義したsetMailTemplateメソッド
  private emitAddress(value: string) {
  }

  private created() {
    // 確認画面表示のdefault文字色設定
    if (!this.textColor) {
      this.privateTextColor = 'black--text';
    } else {
      this.privateTextColor = this.textColor;
    }
    // this.clearable = !(this.readonly === 'readonly' || this.disabled === 'disabled');
    if (this.invaildMessage) {
      this.privateInvaildMessage = this.invaildMessage;
    }
    // validationルールの設定
    this.rules = [(value: string) => (this.isValidateRequired(value)) || '必須項目です。'];
  }
  // validationの設定
  private isValidateRequired(value: string) {
    return this.validate.isValidateRequired(value, this.required);
  }
}
